import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export default function getClosestPoint(val, _ref) {
  var marks = _ref.marks,
      step = _ref.step,
      min = _ref.min,
      max = _ref.max;

  if (max < min) {
    throw new Error("\"max\" should be greater than \"min\". Got \"min\" = ".concat(min, ", \"max\" = ").concat(max));
  }

  var points = Object.keys(marks || {}).map(parseFloat);

  if (step !== null) {
    var maxSteps = Math.floor((max - min) / step);
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }

  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, _toConsumableArray(diffs)))];
}